import { SummaryFeatureList } from '~app/pages/Pricing/transformers/summary/types';

// The list of the order in which summary display features should be shown.
// Also maps where feature set items should be combined or split for display purposes
// To make TS happy we still have to map standalone features to an empty array
const FormsFeatureList: SummaryFeatureList = [
  'grow_2792_user',
  'grow_2792_survey_create_limit', // Unlimited number of surveys and forms
  'unlimited_questions', // Unlimited questions per survey/unlimited fields per form
  'grow_2792_question_types',
  'response_count', // 200 responses per month
  'support', // 24/7 email support
  'grow_2792_analyze_export_enabled', // Data exports (CSV, PDF, PPT, XLS)
  'grow_2792_website_embed', // Website embed
  'grow_2792_zapier_integrations', // 5000+ integrations with Zapier
  'skip_logic', // Skip logic
  'grow_2792_survey_branding',
  'payment_qt', // Accept Payments
  'file_upload', // File upload
];

export default FormsFeatureList;
